module.exports = __webpack_public_path__ + "static/img/deviceAddBg.9165207f.png";